import { useSearchParams, useLocation } from 'react-router-dom';

function HaloDebugPage() {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const allParams = {};
  for (const [key, value] of searchParams.entries()) {
    allParams[key] = value;
  }

  return (
    <div className="p-8 font-mono text-sm">
      <h1 className="text-2xl font-bold mb-4">Halo PSA Debug Page</h1>

      <div className="mb-6 p-4 bg-gray-100 rounded">
        <h2 className="font-bold mb-2">Full URL:</h2>
        <div className="break-all">{window.location.href}</div>
      </div>

      <div className="mb-6 p-4 bg-gray-100 rounded">
        <h2 className="font-bold mb-2">Query String:</h2>
        <div className="break-all">{location.search || '(none)'}</div>
      </div>

      <div className="mb-6 p-4 bg-gray-100 rounded">
        <h2 className="font-bold mb-2">All Query Parameters:</h2>
        {Object.keys(allParams).length > 0 ? (
          <table className="w-full">
            <thead>
              <tr className="text-left border-b">
                <th className="pb-2">Key</th>
                <th className="pb-2">Value</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(allParams).map(([key, value]) => (
                <tr key={key} className="border-b">
                  <td className="py-2 pr-4">{key}</td>
                  <td className="py-2">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-gray-500">No parameters found</div>
        )}
      </div>

      <div className="p-4 bg-yellow-50 border border-yellow-200 rounded">
        <p className="text-sm">
          <strong>Instructions:</strong> Use this URL in your Halo PSA iframe with different variable formats:
        </p>
        <ul className="mt-2 text-xs space-y-1 list-disc list-inside">
          <li>Try: <code>?ticketId=[ticketid]</code></li>
          <li>Try: <code>?ticketId=[id]</code></li>
          <li>Try: <code>?ticketId=$ticketid</code></li>
          <li>Try: <code>?test1=[ticketid]&test2=[id]&test3=$ticketid</code></li>
        </ul>
        <p className="mt-2 text-xs">
          Whichever parameter shows a real ticket number is the correct format!
        </p>
      </div>
    </div>
  );
}

export default HaloDebugPage;
